// C:\laragon\www\SMARTCAT\smartcat-v4-frontend\src\services\report\exportService.js
import apiHeader from '@/helpers/apiHeader';

const exportService = {
  exportReport(reportType) {
    return apiHeader.get('report/export-data/export', {
      params: { type: reportType }, // Gunakan query parameter ?type=...
      responseType: 'blob' // Penting untuk file download
    });
  }
};

export default exportService;